import {
  DEFAULT_LEARNING_LANGUAGE_CODE,
  isSupportedLearningLanguageCode,
  normalizeLearningLanguageCode,
} from '../constants/learningLanguages';

export function mergeLearningLanguages(languageCodes, preferredLanguage = null) {
  const merged = [
    ...(Array.isArray(languageCodes) ? languageCodes : []),
    ...(preferredLanguage ? [preferredLanguage] : []),
  ]
    .map((code) => normalizeLearningLanguageCode(code, DEFAULT_LEARNING_LANGUAGE_CODE))
    .filter((code) => isSupportedLearningLanguageCode(code))
    .filter((code, index, values) => values.indexOf(code) === index);

  return merged.length > 0 ? merged : [DEFAULT_LEARNING_LANGUAGE_CODE];
}
